import InfiniteScroll from './InfiniteScroll';

$(function() {
  $('.infinite-scroll').each((i, el) => {
    new InfiniteScroll($(el));
  });
});
